<div *ngIf='failed && failed.length' class='FailedMovedContacts'>
  <div class='alert alert-warning'>
    <p>Action completed successfully. The following contacts couldn't be moved.</p>
  </div>
  <mat-list>
    <ng-container *ngFor='let item of failed'>
      <mat-list-item>Contact ID: {{ item.contact_id }}: {{ item.message }}</mat-list-item>
    </ng-container>
  </mat-list>
</div>